import React from "react";
import PropTypes from "prop-types";

class SubmittedBy extends React.Component {
  render() {
    return (
      <tr>
        <th>Submitted By</th>
        <td>
          {this.props.user ? (
            <a
              href={"/users/" + this.props.user.id}
              className="word-wrap styled-link pointer-hand"
            >
              {this.props.user.last_name + ", " + this.props.user.first_name}
            </a>
          ) : (
            <i>{this.props.alternative || 'Unknown'}</i>
          )}
        </td>
      </tr>
    );
  }
}

SubmittedBy.propTypes = {
  user: PropTypes.object,
  alternative: PropTypes.string
};

export default SubmittedBy;
